import { render, staticRenderFns } from "./Catlog.vue?vue&type=template&id=477f7921&scoped=true"
import script from "./Catlog.vue?vue&type=script&lang=js"
export * from "./Catlog.vue?vue&type=script&lang=js"
import style0 from "./Catlog.vue?vue&type=style&index=0&id=477f7921&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f7921",
  null
  
)

export default component.exports